export enum AiEventMessageRole {
    SYSTEM = 'system',
    USER = 'user',
    ASSISTANT = 'assistant'
}
